import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'prizm-library-requirements',
  templateUrl: './library-requirements.component.html',
  styleUrls: ['./library-requirements.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LibraryRequirementsComponent {}
